module.exports = __webpack_public_path__ + "img/borderAngleBracesWhite.cfb07442.svg";